import { StandardEvents } from '@shopify/events';
const update = count => {
  if (typeof count === 'number') document.querySelectorAll('[data-ca-cart-count]').forEach(el => { el.textContent = String(count); });
};
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  event.promise?.then(({cart, detail}) => update(cart?.totalQuantity ?? detail?.itemCount)).catch(() => {});
});
window.addEventListener('pageshow', event => {
  if (!event.persisted) return;
  const cartLink = document.querySelector('.ca-cart');
  if (!cartLink) return;
  const url = new URL(cartLink.href);
  url.pathname = url.pathname.replace(/\/$/, '') + '.js';
  fetch(url, {headers:{Accept:'application/json'}}).then(r => r.ok ? r.json() : null).then(cart => { if (cart) update(cart.item_count); }).catch(() => {});
});
